
export class CopyCurrencyDto {
    From: Date;
    To: Date;
}